import './index.scss';
// import React, { useEffect, useState } from "react";
import {
    DndContext,
    closestCenter,
    useSensor,
    useSensors,
    TouchSensor,
    MouseSensor,
    PointerSensor
} from '@dnd-kit/core';
import {
    arrayMove,
    SortableContext,
    sortableKeyboardCoordinates,
    verticalListSortingStrategy,
} from '@dnd-kit/sortable';

import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import { IconLessonInActive } from '../../../icons/svgs';
import SlideItemElement from './slideItemElement';
import he from 'he';

function ModalReorderSlides({slides, lessonTitle, selectedSlide, setSelectedSlide, selectedSlideIndex, setSelectedSlideIndex, setSlides, reRender}) {
    const sensors = useSensors(
        useSensor(MouseSensor),
        useSensor(TouchSensor, {
            coordinateGetter: sortableKeyboardCoordinates,
        }),
    );

    const handleClick = (index) => {
        const slide = slides[index];
        setSelectedSlide(slide);
        setSelectedSlideIndex(index);
    }

    const handleDragStart = (event) => {
        const activeIndex = event.active.data.current.sortable.index;
        handleClick(activeIndex);
    }
    const handleDragEnd = (event) => {
        const { active, over } = event;

        if (!active) {
            return;
        }
        if (!over) {
            return;
        }

        if (active.id !== over.id) {

            const firstIndex = 0;
            const lastIndex = (slides.length) - 1;
            const toOverIndex = over.data.current.sortable.index;
            const firstSlideCanRearrange = slides[firstIndex].template?.canRearrange();
            const lastSlideCanRearrange = slides[lastIndex].template?.canRearrange();

            // disable move to first and last
            // if (toOverIndex === firstIndex || toOverIndex === lastIndex) {
            //     return;
            // }

            // disable move to first by slide on first
            if (!firstSlideCanRearrange && toOverIndex === firstIndex) {
                return;
            }
            // disable move to last by slide on last
            if (!lastSlideCanRearrange && toOverIndex === lastIndex) {
                return;
            }

            setSlides((items) => {
                const oldIndex = items.indexOf(items.find((item) => item.id === active.id));
                const newIndex = items.indexOf(items.find((item) => item.id === over.id));

                // if old index is selected, so move selected to new index
                if (oldIndex === selectedSlideIndex) {
                    handleClick(newIndex);
                }

                return arrayMove(items, oldIndex, newIndex);
            });
        }
    }

    // useEffect(() => {
    //     if (selectedSlide) {
    //         setSaveDisabled(selectedSlide.saveDisabled)
    //     }
    // });

    return (
        <div className={`tbcourse-modal tbcourse-modal-reorder-slides modal`} id="tbcourse-modal-reorder-slides" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" role="dialog" aria-hidden="true">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header border-0">
                        <h5 className="modal-title font-size-28">Slide List</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body font-size-14 font-family-inter">
                        <div className="selecting-lesson-type bg-white rounded-12">
                            <div className={`text-header font-size-18 font-weight-700 py-3 text-ellipsis`}>
                                <span className="icon-inactive me-2"><IconLessonInActive /> </span>
                                {he.decode(lessonTitle)}
                            </div>
                            <div className=''>
                            <DndContext
                                    sensors={sensors}
                                    collisionDetection={closestCenter}
                                    onDragStart={handleDragStart}
                                    onDragEnd={handleDragEnd}
                                    modifiers={[restrictToVerticalAxis]}
                                >
                                    <SortableContext
                                        items={slides}
                                        strategy={verticalListSortingStrategy}
                                    >
                                        {slides.map((item, index) => (
                                            <SlideItemElement
                                                selectedSlideIndex={selectedSlideIndex}
                                                index={index}
                                                slide={item}
                                                handleClick={handleClick}
                                                id={item.id}
                                                key={index}
                                                handle={true}
                                                setNodeRef={() => {}}
                                            />
                                        ))}
                                    </SortableContext>
                                </DndContext>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ModalReorderSlides;